import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z"
}), 'ViewArray');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewArray.js
// module id = 7070
// module chunks = 2